import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { COOKIES_POLICIES } from 'src/constants/routes';
import css from './cookies-notice.module.scss';
import Cookies from 'js-cookie';

export const COOKIE_NAME = 'user_consent';

export default function CookiesNotice() {
  const [isShown, setIsShown] = useState(true);

  const handleAgree = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: 30 });
    setIsShown(false);
  };

  useEffect(() => {
    const consent = Cookies.get(COOKIE_NAME);
    setIsShown(!consent);
  }, []);

  if (!isShown) return null;

  return (
    <div className={css.cookiesNotice}>
      <div className={css.container}>
        <p>
          Ми використовуємо файли cookie, щоб забезпечити вам найкращий досвід роботи на нашому веб-сайті. Продовжуючи
          користуватися сайтом, ви погоджуєтесь на використання файлів cookie. Детальніше про{' '}
          <Link to={COOKIES_POLICIES.path}>політику використання файлів cookie.</Link>
        </p>
        <div>
          <button onClick={handleAgree}>Погоджуюсь</button>
        </div>
      </div>
    </div>
  );
}
